/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {serviceGetSyncEntities} from '../api'

export const useMutationServiceGetSyncEntities = createReactQueryMutationHook('serviceGetSyncEntities', serviceGetSyncEntities)
